import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { NmsVersionNotificationMessage } from "./nms-version-notification.models";
import { webSocket } from "rxjs/webSocket";
import { ANGULARJS_ROOTSCOPE } from "../upgraded-provider/upgraded-providers";

/**
 * Service que se conecta a um Websocket para recebimento de notificações de atualizações disponíveis para o NMS.
 */
@Injectable({
    providedIn: "root"
})
export class NmsVersionNotificationWebSocketService {
    private webSocketUrl: string;
    private connectedWebSocket: Subject<NmsVersionNotificationMessage>;

    constructor(@Inject(DOCUMENT) private document: Document, @Inject(ANGULARJS_ROOTSCOPE) private rootScope) { }

    public connect = (username: string): void => {
        const { location: { host } } = this.document;
        this.webSocketUrl = `wss://${host}${username}`;
        this.connectedWebSocket = webSocket(this.webSocketUrl);
        this.connectedWebSocket.subscribe(
            (notification: NmsVersionNotificationMessage) => this.onMessage(notification), this.onError, this.onClose);
    }

    public disconnect = (): void => {
        this.connectedWebSocket.unsubscribe();
    }

    private onMessage(notification: NmsVersionNotificationMessage): void {
        this.rootScope.lastNmsVersionAvailable = notification;
    }

    private onError(err: any): void {
        console.error(err);
    }

    private onClose(): void {
        console.log(`WebSocket ${this.webSocketUrl} was closed.`);
    }
}
